export default "__VITE_ASSET__m9FXeHKU__"